import React, { useState, memo } from "react"
import { set, del } from "idb-keyval"
import { useStore } from '../../teafuljs/store'
import { makeStyles } from "@material-ui/core/styles"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"
import Collapse from "@material-ui/core/Collapse"
import ExpandLess from "@material-ui/icons/ExpandLess"
import ExpandMore from "@material-ui/icons/ExpandMore"
import { getTranslation } from "../../scripts/getTranslation"
import BibleBookList from "../../data/BookChapterList.json"
import { Typography } from "@material-ui/core"
import Divider from "@material-ui/core/Divider"
import CheckCircle from "@material-ui/icons/CheckCircle"
import Brightness1Outlined from "@material-ui/icons/Brightness1Outlined"
import SegmentTitles from "../../data/SegmentTitles.json"
import SegmentTimePeriods from "../../data/SegmentTimePeriods.json"
import { recordEvent } from "../../apis/googleAnalytics"
import { checkReadMark } from "../../scripts/checkReadMark"
import CheckMark from '../CheckMark'

const useStyles = makeStyles(theme => ({
  root: {
    width: "75vw",
    maxWidth: 500,
    paddingLeft: 10,
    paddingRight: 10,
  },
  segmentOrderTitle: {
    position: "relative",
    width: "100%",
    textAlign: "center",
  },
  toggleSegmentView: {
    display: "flex",
    justifyContent: "center",
  },
  toggleSegmentViewButton: {
    margin: 2.5,
    width: 100,
    height: 20,
    textAlign: "center",
    fontSize: 10,
    fontWeight: "bold",
    textTransform: "uppercase",
    verticalAlign: "middle",
    borderRadius: 10,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  bookItem: {
    padding: `0px 10px`,
    fontSize: 12,
    textTransform: "uppercase",
    display: "flex",
    backgroundColor: theme.palette.secondary.main,
    color: "white",
    marginBottom: 3,
  },
  segmentListItem: {
    padding: `0 0 0 10px`,
    marginBottom: 10,
    marginRight: 10,
    // marginTop: 10,
    color: theme.palette.secondary.main,
  },
  segmentItemInfo: {
    fontSize: 12,
    display: "flex",
    flexDirection: "column",
    height: "fit-content",
  },
  segmentTitle: {
    minWidth: 0,
    marginLeft: 33,
    flex: 1,
    fontWeight: "bold",
    paddingBottom: 5,
    // paddingTop: 3,
  },
  segmentInfo: {
    display: "flex",
    fontSize: 10,
    fontWeight: "bold",
  },
  segmentRef: {
    flex: 1,
    padding: "0 0 0 10px",
    textAlign: "left",
    textTransform: "uppercase",
  },
  segmentTP: {
    flex: 1,
    alignItems: "right",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "left",
    marginLeft: 33,
    fontSize: 10,
    lineHeight: 1,
    paddingBottom: 10,
  },
  checkMarkDiv: {
    height: "25px",
    width: "25px",
    paddingBottom: 5,
  },
}))

const SegmentListItem = memo(
  ({
    language,
    version,
    translations,
    currentSegmentID,
    segment,
    close,
    versificationType,
  }) => {
    const classes = useStyles()
    const [readPlan, setReadPlan] = useStore.readPlan();
    const [readPlanID, setReadPlanID] = useStore.readPlanID();
    const [history, setHistory] = useStore.history();
    const setCurrentSegmentID = useStore.currentSegmentID()[1]
    const rpKey = readPlan
      ? readPlan[`readingPlan-${language}-${version}-${segment}`]
      : null
    const [read, updateRead] = useState(rpKey)

    // function checkReadPlanMark(segment) {
    //   if (readPlan[`readingPlan-${language}-${version}-${segment}`] === true) {
    //     const newReadObj = Object.assign(readPlan, {
    //       [`readingPlan-${language}-${version}-${segment}`]: false,
    //     })
    //     setReadPlan(newReadObj)
    //     setReadPlanID(readPlanID + 1)
    //   } else {
    //     const newReadObj = Object.assign(readPlan, {
    //       [`readingPlan-${language}-${version}-${segment}`]: true,
    //     })
    //     setReadPlan(newReadObj)
    //     setReadPlanID(readPlanID + 1)
    //   }
    // }

    // async function checkReadMark(segment) {
    //   const rpKey = `readingPlan-${language}-${version}-${segment}`
    //   if (read) {
    //     del(rpKey)
    //     await checkReadPlanMark(segment)
    //     updateRead(false)
    //   } else {
    //     recordEvent(
    //       "Read Segment",
    //       `${language}-${version}`,
    //       `${language}-${version}-${segment}`
    //     )
    //     set(rpKey, true)
    //     await checkReadPlanMark(segment)
    //     updateRead(true)
    //   }
    // }

    const getRef = segmentData => {
      if (segmentData.book.length > 1) {
        return `${getTranslation(
          translations,
          language,
          "Books",
          `abbrev_${segmentData.book[0]}`
        )} ${
          versificationType === "standard" && segmentData.standardRef
            ? segmentData.standardRef.split("-")[0]
            : segmentData.ref.split("-")[0]
        }-${getTranslation(
          translations,
          language,
          "Books",
          `abbrev_${segmentData.book[1]}`
        )} ${
          versificationType === "standard" && segmentData.standardRef
            ? segmentData.standardRef.split("-")[1]
            : segmentData.ref.split("-")[1]
        }`
      } else {
        return `${getTranslation(
          translations,
          language,
          "Books",
          `abbrev_${segmentData.book[0]}`
        )} ${
          versificationType === "standard" && segmentData.standardRef
            ? segmentData.standardRef
            : segmentData.ref
        }`
      }
    }

    const goToSegment = segment => {
      setHistory([
        {
          page: window.location.pathname,
          language: language,
          version: version,
          segment: currentSegmentID,
          scrollY: window.scrollY,
        },
      ...history])
      recordEvent(
        "Header Navigation",
        `${language}-${version}`,
        segment
      )
      setCurrentSegmentID(segment)
      close()
    }

    const displayTimePeriods = array => {
      const first = getTranslation(translations, language, "UI", array[0])
      const last =
        array.length > 1
          ? getTranslation(
              translations,
              language,
              "UI",
              array[array.length - 1]
            )
          : null
      if (array.length > 1) {
        return [first, last]
      } else {
        return [first]
      }
    }
    console.log('Segment Select', readPlan)
    return (
      <ListItem
        component={props => (
          <div className={classes.segmentListItem}>
            <div className={classes.segmentItemInfo}>{props.children}</div>
          </div>
        )}
      >
        <Typography
          noWrap
          className={classes.segmentTitle}
          onClick={() => goToSegment(segment)}
        >
          {getTranslation(translations, language, "Titles", segment)}
        </Typography>
        {segment.substring(0, 1) === "S" && (
          <React.Fragment>
            <div className={classes.segmentInfo}>
              <div className={classes.checkMarkDiv}>
                <CheckMark language={language} version={version} id={segment} empty />
              </div>
              <div
                className={classes.segmentRef}
                onClick={() => goToSegment(segment)}
              >
                {getRef(SegmentTitles[segment])}
              </div>
            </div>
            <div
              className={classes.segmentTP}
              onClick={() => goToSegment(segment)}
            >
              {displayTimePeriods(SegmentTimePeriods[segment]).join(", ")}
            </div>
          </React.Fragment>
        )}
        <Divider />
      </ListItem>
    )
  }
)

const BookListItem = memo(
  ({
    content,
    language,
    version,
    translations,
    currentSegmentID,
    close,
    book,
    versificationType,
  }) => {
    const classes = useStyles()
    const [open, setOpen] = React.useState(false)

    const handleClick = () => {
      setOpen(!open)
    }

    const getSegments = book => {
      return content[book].segments
    }

    return (
      <React.Fragment>
        <ListItem
          component={props => (
            <div className={classes.bookItem} onClick={handleClick}>
              {props.children}
            </div>
          )}
        >
          <ListItemText
            primary={getTranslation(
              translations,
              language,
              "Books",
              BibleBookList[book].bookName
            )}
          />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding className={classes.segmentList}>
            {content &&
              getSegments(book).map(segment => (
                <SegmentListItem
                  key={segment}
                  segment={segment}
                  close={close}
                  language={language}
                  version={version}
                  translations={translations}
                  currentSegmentID={currentSegmentID}
                  content={content}
                  versificationType={versificationType}
                />
              ))}
          </List>
        </Collapse>
      </React.Fragment>
    )
  }
)

const NestedList = memo(
  ({
    closeSegmentSelect,
    segmentOrder,
    content,
    language,
    version,
    translations,
    currentSegmentID,
    versificationType,
  }) => {
    const classes = useStyles()

    const getAvailableBooks = content => {
      return Object.keys(BibleBookList).filter(
        b => Object.keys(content).indexOf(b) !== -1
      )
    }

    return (
      <div>
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          className={classes.root}
        >
          {segmentOrder === "Bible" &&
            content &&
            getAvailableBooks(content).map(book => (
              <BookListItem
                key={book}
                book={book}
                close={closeSegmentSelect}
                language={language}
                version={version}
                translations={translations}
                currentSegmentID={currentSegmentID}
                content={content}
                versificationType={versificationType}
              />
            ))}
        </List>
      </div>
    )
  }
)

export default NestedList
